import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { BoobleModalService } from 'booble-modal';
import { IndividualAccountDto } from 'src/app/domain/models/dto/individual-account.dto';
import { FatcaComponent } from 'src/app/shared/modals/fatca/fatca.component';
import { PepComponent } from 'src/app/shared/modals/pep/pep.component';
import { AuthenticationService } from 'src/app/shared/services';
import { IndividualAccountService } from 'src/app/shared/services/individual-account.service';

@Component({
  selector: 'app-fatca-pep',
  templateUrl: './fatca-pep.component.html',
  styleUrls: ['./fatca-pep.component.scss'],
})
export class FatcaPepComponent implements OnInit {
  private readonly notifier: NotifierService;
  userLogin: string;
  individualId: number;
  tenant: string = '';
  public loading: boolean;

  individualComplementaryForm: FormGroup;

  get individualComplementaryFormControl() {
    return this.individualComplementaryForm.controls;
  }

  get individualAccount(): IndividualAccountDto {
    const individual = this.individualComplementaryForm.getRawValue();

    return individual;
  }
  

  set individualAccount(individual: IndividualAccountDto) {
    if (individual) {
      individual.id = Number(this.individualId);
      this.individualComplementaryForm.patchValue(individual);
      this.individualComplementaryForm.controls[
        'identificationNumber'
      ].setValue(individual?.foreignAccountData?.identificationNumber);
    }
  }

  constructor(
    fb: FormBuilder,
    notifierService: NotifierService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly authService: AuthenticationService,
    private readonly individualService: IndividualAccountService,
    private readonly modalService: BoobleModalService
  ) {
    this.notifier = notifierService;
    this.userLogin = this.authService.getCurrentUserId();
    this.individualId = +this.authService.getIndividualId();

    this.individualComplementaryForm = fb.group({
      id: [],
      isFATCA: [false, [Validators.required, Validators.pattern('.*\\S.*')]],
      isPEP: [false, [Validators.required, Validators.pattern('.*\\S.*')]],
      identificationNumber: [''],
    });
  }

  ngOnInit() {
    this.individualService.get(this.individualId).subscribe((getResult) => {
      this.individualAccount = getResult.data;
    });
    this.route.paramMap.subscribe((params) => {
      const result = params.get('tenant');

      if (result) this.tenant = params.get('tenant');
    });
  }

  openFatcaModal() {
    this.modalService.present(FatcaComponent);
  }


  openPepModal() {
    this.modalService.present(PepComponent);
  }

  requiredSSN(form: FormGroup, value: boolean) {
    if (value && form.contains('identificationNumber')) {
      form.controls['identificationNumber'].setValidators([
        Validators.required,
        Validators.pattern('.*\\S.*'),
      ]);
    } else if (!value && form.contains('identificationNumber')) {
      form.controls['identificationNumber'].clearValidators();
      form.controls['identificationNumber'].setErrors(null);
      form.controls['identificationNumber'].updateValueAndValidity();
      form.controls['identificationNumber'].setValue('');
    }
  }



  goBack() {
    this.router.navigate([`${this.tenant}/onboardings/individual-data`]);
  }

  update() {
    this.loading = true;

    this.individualService
      .putComplementary(this.individualAccount, Number(this.individualId))
      .subscribe({
        next: () => {
          this.router.navigate([
            `${this.tenant}/onboardings/individual-documents`,
          ]);
        },
        error: (err) => {
          this.loading = false;
        },
      });
  }
}
